import { useAuditClientConfigQuery } from '@app/modules/audit/hooks/useAuditClientConfigQuery';
import { auditReports } from '@mi-front/api-clients';
import * as yup from 'yup';

export const gipExportIncludeAudioValues = [0, 5, 15, 30, 45, 60, 90, 120, 180, 300];

export function useGipExportSetup(
  initialConfig: auditReports.GipEvidenceExportOptionsDto | undefined,
  reportType: string,
) {
  const auditClientConfigQuery = useAuditClientConfigQuery();

  const definitionsQuery = auditReports.useListReportDefinition({ reportType });

  if (!auditClientConfigQuery.data || !definitionsQuery.data) {
    return;
  }

  const pathFormats = auditClientConfigQuery.data.evidenceExport?.pathFormats ?? [];

  const initialDefinitionId = definitionsQuery.data?.find((d) => d.isDefault)?.id;

  const initialValues: auditReports.GipEvidenceExportOptionsDto = initialConfig ?? {
    audioMatchIncludeBefore: 60,
    audioMatchIncludeAfter: 60,
    ...(initialDefinitionId ? { definitionId: initialDefinitionId } : { definitionId: undefined }),
    pathFormat: {
      formatId: pathFormats.find((f) => f.default)?.id || pathFormats[0]?.id || undefined,
      formatCustomText: undefined,
    },
  };

  return {
    pathFormats: auditClientConfigQuery.data?.evidenceExport?.pathFormats ?? [],
    initialValues,
    validationSchema: yup.object().shape({
      audioMatchIncludeBefore: yup.mixed().required(),
      audioMatchIncludeAfter: yup.mixed().required(),
      excludeVersion: yup.boolean(),
      publicLink: yup.boolean(),
      definitionId: yup.string(),
    }),
    definitions: definitionsQuery.data,
  };
}
